import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { ContainerDto } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'

interface Props {
  container: ContainerDto
  onAssign: (container: ContainerDto) => Promise<void> | void
  suggested?: boolean
}

export const AssignContainerListCard: FC<Props> = ({ container, onAssign, suggested }) => {
  const handleAssign = () => onAssign(container)
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Paper variant='outlined' sx={{ p: 2, mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1.5,
        }}
      >
        <Stack direction='row' alignItems='center' spacing={theme.customSpacing.xs}>
          <Typography variant='h6' sx={{ fontWeight: 600, letterSpacing: '0.5px' }}>
            {container.number}
          </Typography>
          {suggested && (
            <ColoredLabel color='info' label={t('suggestedContainer', 'Suggested container')} />
          )}
        </Stack>

        <Button
          variant='contained'
          color='inherit'
          data-cy='assign-nnr-order-container'
          onClick={handleAssign}
        >
          {t('assign', 'Assign')}
        </Button>
      </Box>

      <Box>
        <Typography
          variant='overline'
          display='block'
          sx={{ lineHeight: 1.2, color: 'text.secondary' }}
        >
          {t('ISO')}
        </Typography>
        <Typography variant='body1' sx={{ fontWeight: 500 }}>
          {container.isoCode}
        </Typography>
      </Box>
    </Paper>
  )
}
